<template>
  <div class="layout-topbar">
    <div class="layout-topbar-left">
      <router-link :to="{name: 'campaigns.list'}" class="logo">
        <img src="./assets/images/logo.png">
      </router-link>

      <div class="beta-mark">Beta</div>
    </div>

    <AppMenu :menuMode="menuMode" :colorScheme="colorScheme" :menuActive="menuActive"
             :activeInlineProfile="activeInlineProfile"
             @sidebar-mouse-over="onSidebarMouseOver" @sidebar-mouse-leave="onSidebarMouseLeave"
             @toggle-menu="onToggleMenu" @change-inlinemenu="onChangeActiveInlineMenu"
             @menu-click="onMenuClick" @root-menuitem-click="onRootMenuItemClick" @menuitem-click="onMenuItemClick"/>

          <div class='buttons-menu'>
            <router-link :to="{name: 'campaigns.list'}" class="link-btn-color">
              <span>Campaigns</span>
            </router-link>

            <router-link :to="{name: 'dashboard'}" class="link-btn-color">
              <span>Dashboard</span>
            </router-link>
          </div>

    <div class="layout-topbar-right">
      <ul class="layout-topbar-right-items">
        <li id="profile" class="profile-item" :class="{'active-topmenuitem': topbarMenuActive}">
          <a href="#" @click.prevent="onTopbarItemClick($event, 'profile')">
            <Avatar :image="currentUser.avatar?.thumbnail" class="p-mr-3" />
            <i class="pi pi-angle-down"></i>
          </a>

          <ul class="fadeInDown">
            <li role="menuitem">
              <router-link :to="{name: 'account.settings'}">
                <i class="pi pi-fw pi-user"></i>
                <span>My account</span>
              </router-link>
            </li>

            <li role="menuitem">
              <a href="#" @click="logout">
                <i class="pi pi-fw pi-sign-out"></i>
                <span>Logout</span>
              </a>
            </li>
          </ul>
        </li>
        <li class="notification-item">
          <a href="#" @click.prevent="showNotifications">
            <i class="topbar-icon pi pi-fw pi-bell"></i>
            <span class="topbar-badge" v-if="notificationCount">{{ notificationCount }}</span>
            <span class="topbar-item-name">Notifications</span>
          </a>

          <OverlayPanel ref="notificationsOverlay">
            <Notifications />
          </OverlayPanel>
        </li>
        <li class="swap-brand-item">
          <SwapBrand :current-brand="{}" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import AppMenu from './AppMenu.vue';
import {logout} from "./services/Auth";
import SwapBrand from "./components/SwapBrand";
import {currentUserQuery} from "./queries/userQueries";
import {computed, ref} from "vue";
import Notifications from './components/Notifications';
import {useStore} from 'vuex';

const props = defineProps({
  items: Array,
  menuMode: String,
  colorScheme: String,
  topbarMenuActive: {
    type: Boolean,
    default: false
  },
  menuActive: {
    type: Boolean,
    default: false
  },
  activeInlineProfile: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits([
  'menu-click',
  'menuitem-click',
  'root-menuitem-click',
  'menubutton-click',
  'sidebar-mouse-over',
  'sidebar-mouse-leave',
  'toggle-menu',
  'change-inlinemenu',
  'topbar-item-click'
]);

const store = useStore();
const {data} = currentUserQuery();

const createShipmentModalVisible = ref(false);
const notificationsOverlay = ref();
const notificationCount = computed(() => store.getters['notifications/notifications'].length)
const currentUser = computed(() => data.value ? data.value.data : {});

const showCreateShipmentModal = () => createShipmentModalVisible.value = true;
const onMenuClick = (event) => emit('menu-click', event);
const onMenuItemClick = (event) => emit('menuitem-click', event);
const onRootMenuItemClick = (event) => emit('root-menuitem-click', event);
const onMenuButtonClick = (event) => emit('menubutton-click', event);
const onTopbarItemClick = (event, item) => emit('topbar-item-click', event, item);
const onSidebarMouseOver = () => emit('sidebar-mouse-over');
const onSidebarMouseLeave = () => emit('sidebar-mouse-leave');
const onToggleMenu = (event) => emit('toggle-menu', event);
const onChangeActiveInlineMenu = () => emit('change-inlinemenu');
const isOverlay = () => props.menuMode === 'overlay';

const showNotifications = (event) => {
  notificationsOverlay.value.toggle(event);
}

</script>

<style lang="scss" scoped>
@import './assets/sass/_theme_variables.scss';

.beta-mark {
  background: $gray;
  padding: toRem(4) toRem(12);
  font-weight: 500;
  font-size: toRem(14);
  color: $shade600;
  margin-left: toRem(8);
  border-radius: 4px;
}

.link-btn-color {
  font-weight: 400;
  font-size: toRem(16);
  color: #676B89;
  line-height: 19.36px
}
.buttons-menu{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 32px;

  position: absolute;
  width: 268px;
  height: 32px;
  left: calc(50% - 268px/2 - 91.5px);
}

.buttons-menu a:hover, .buttons-menu .router-link-active{
  color: $shade700;
  font-weight: 500;
}

</style>
